<template>
    <div class="relative p-4 card">
        <template v-if="title != null">
            <div class="text-lg font-bold text-gray-500">{{ title }}</div>
        </template>
        <div
            class="mt-2"
            :style="{ height: heightComputed, maxHeight: heightComputed }"
        >
            <a-alert
                style="width: 200px"
                :message="
                    `เลือกวันที่ : ${selectedValue &&
                        selectedValue.format('YYYY-MM-DD')}`
                "
            />

            <a-calendar
                v-if="list_result.length > 0"
                :value="date"
                @select="onSelect"
                @panelChange="onPanelChange"
            >
                <template #dateCellRender="{ current }">
                    <ul class="events">
                        <li
                            v-for="item in getListData(current)"
                            :key="item.content"
                        >
                            <a-badge :status="item.type" :text="item.content" />
                        </li>
                    </ul>
                </template>
                <template #monthCellRender="{ current }">
                    <div v-if="getMonthData(current)" class="notes-month">
                        <section>{{ getMonthData(current) }}</section>
                        <span>Backlog number</span>
                    </div>
                </template>
            </a-calendar>

            <a-modal
                v-model:visible="visibleshoppingcart"
                width="1400px"
                style="top: 20px"
                title="รายการ"
                @ok="handleOkshoppingcart"
            >
                <div v-if="!isshowspin">
                    <div class="pdf_icon" @click="getexcelshoppingg_fill_in">
                        <u class="pr-2"
                            >Export Excel Salepage (ลูกค้ากรอกข้อมูล ex.แผ่นทอง
                            ว/ด/ป )</u
                        >
                        <FileExcelOutlined :style="{ fontSize: '32px' }" />
                    </div>
                    <div class="pdf_icon" @click="getexcelshopping">
                        <u class="pr-2">Export Excel (สินค้าที่ลูกค้าสั่ง)</u>
                        <FileExcelOutlined :style="{ fontSize: '32px' }" />
                    </div>
                    <div>
                        <a-alert
                            style="width: 200px"
                            :message="
                                `มีลูกค้าสั่งสินค้า : ${dataSources?.length} รายการ`
                            "
                        />
                    </div>
                </div>
                <div v-else-if="isshowspin" class="text-center pb-4">
                    <a-tag color="processing">
                        <template #icon>
                            <sync-outlined :spin="true" />
                        </template>
                        กำลังสร้างไฟล์...
                    </a-tag>
                </div>

                <a-table
                    v-if="dataSources"
                    :scroll="{ x: 1300, y: 1000 }"
                    :columns="columns"
                    :data-source="dataSources"
                    @change="handleTableChange"
                    @expandFixed="true"
                    :row-class-name="
                        (_record, index) =>
                            index % 2 === 1 ? 'table-striped' : null
                    "
                >
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.dataIndex === 'Order'">
                        </template>
                        <template v-if="column.dataIndex === 'ProductImage'">
                            <div v-if="record.ShoppingJson">
                                <div
                                    v-for="(item, index) in JSON.parse(
                                        record.ShoppingJson
                                    )?.order?.orderItems"
                                    :key="`day-${index}`"
                                >
                                    <a-image
                                        :width="100"
                                        :src="item.product.imageUrl"
                                    />
                                </div>
                            </div>
                        </template>

                        <template v-if="column.dataIndex === 'StatusPayment'">
                            <div>
                                <a-tag
                                    v-if="record.StatusPayment == 'complete'"
                                    color="#87d068"
                                    >ชำระเงินเรียบร้อย</a-tag
                                >
                                <a-tag
                                    v-else-if="record.PaymentType == 'cod'"
                                    color="#87d068"
                                    >cod</a-tag
                                >

                                <a-tag
                                    v-else-if="
                                        record.PaymentType == 'transfer-money'
                                    "
                                    color="warning"
                                >
                                    <template #icon>
                                        <ClockCircleOutlined />
                                    </template>
                                    รอตรวจสอบสลิป
                                </a-tag>
                            </div>
                        </template>
                        <template v-if="column.dataIndex === 'PaymentType'">
                            <div>
                                <div v-if="record.PaymentType == 'cod'">
                                    <img
                                        class="rounded"
                                        :width="100"
                                        src="https://namahayan.blob.core.windows.net/assets/cod.png"
                                    />
                                </div>
                                <div
                                    v-else-if="
                                        record.PaymentType == 'transfer-money'
                                    "
                                >
                                    <img
                                        class="rounded"
                                        :width="100"
                                        src="https://namahayan.blob.core.windows.net/assets/mb.jpg"
                                    />
                                </div>
                                <div v-else-if="record.PaymentType == 'beam'">
                                    <div v-if="record.PaymentGetewayResponse">
                                        <p>
                                            <a
                                                :href="
                                                    JSON.parse(
                                                        record.PaymentGetewayResponse
                                                    )?.paymentLink
                                                "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    class="rounded"
                                                    :width="100"
                                                    src="https://namahayan.blob.core.windows.net/assets/beam-thumbnail.png"
                                                />
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <a-tag v-else-if="record.PaymentType == 'free'" color="#37b31b"
                                    >ฟรี</a-tag
                                >
                                <a-tag v-else color="#f50"
                                    >ยังไม่ได้ชำระเงิน</a-tag
                                >
                            </div>
                        </template>
                        <template v-if="column.dataIndex === 'PathSlip'">
                            <div v-if="record.DeliveryJson">
                                <div>
                                    <a-image
                                        :width="100"
                                        :src="
                                            JSON.parse(record.DeliveryJson)
                                                ?.pathURL
                                        "
                                    />
                                </div>
                            </div>
                            <div
                                v-if="!JSON.parse(record.DeliveryJson)?.pathURL"
                            >
                                <a-avatar shape="square" :size="100">
                                    <template #icon><StopOutlined /></template>
                                </a-avatar>
                            </div>
                        </template>

                        <template
                            v-if="column.dataIndex === 'PaymentGetewayResponse'"
                        >
                            <!-- <div v-if="record.PaymentGetewayResponse">
                                PurchaseId : {{JSON.parse(record.PaymentGetewayResponse)?.purchaseId}}</div> -->
                            <div v-if="record.PaymentGetewayResponse">
                                <p>
                                    <a
                                        :href="
                                            JSON.parse(
                                                record.PaymentGetewayResponse
                                            )?.paymentLink
                                        "
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >PaymentLink</a
                                    >
                                </p>
                            </div>
                        </template>

                        <template v-if="column.dataIndex === 'ShoppingJson'">
                            <div v-if="record.ShoppingJson">
                                <div
                                    v-for="(item, index) in JSON.parse(
                                        record.ShoppingJson
                                    )?.order?.orderItems"
                                    :key="`day-${index}`"
                                >
                                    <div>
                                        ชื่อสินค้า {{ item.product.name }}
                                    </div>

                                    <div>ราคา {{ item.product.price }} บาท</div>
                                    <div>
                                        รหัสสินค้า (SKU)
                                        <a-tag color="#2db7f5">{{
                                            item.product.sku
                                        }}</a-tag>
                                    </div>
                                    <div>จำนวน {{ item.quantity }} ชิ้น</div>
                                    <div>
                                        <u>
                                            รวม {{ item.quantity }} X
                                            {{ item.product.price }} =
                                            {{
                                                item.quantity *
                                                    item.product.price
                                            }}
                                            บาท
                                        </u>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="column.dataIndex === 'DeliveryJson'">
                            <div v-if="record.ShoppingJson">
                                <div  >
                                    <a-typography-paragraph copyable>
                                        คุณ
                                        {{
                                            JSON.parse(record.DeliveryJson)
                                                ?.name||'-'
                                        }}
                                        <br />
                                        ที่อยู่.{{
                                            JSON.parse(record.DeliveryJson)
                                                ?.address||'-'
                                        }}
                                        <br />
                                        {{
                                            JSON.parse(record.DeliveryJson)
                                                ?.phone||'-'
                                        }}
                                    </a-typography-paragraph>
                                </div>
                            </div>
                        </template>
                        <template v-if="column.dataIndex === 'ShoppingDate'">
                            <div v-if="record.ShoppingDate">
                                <div>
                                    {{ formatdate(record.ShoppingDate) }}
                                </div>
                            </div>
                        </template>
                    </template>
                </a-table>
            </a-modal>
        </div>
        <FromCreateSell
            v-if="rowselecteddetail.ishowdetail"
            :rowselected="rowselecteddetail"
        ></FromCreateSell>
    </div>
</template>
<script>
import dayjs from "dayjs";
import { message } from "ant-design-vue";
import TableLoad from "@/components/Skeleton/TableLoad";
import FromCreateSell from "@/module/CustomerOrder/SellCreate/component/FromCreateSell.vue";
import { usePagination } from "vue-request";

import { computed, defineComponent, onMounted, ref, reactive, h } from "vue";
import axios from "axios";
import BzbsUser from "@/core/UserManagement/callapi/BzbsUser";

import moment from "moment";
import "moment/locale/th";
import Pixcelview from "./Pixcelview.vue"; // without this line it didn't work

import {
    FilePdfOutlined,
    FileExcelOutlined,
    LoadingOutlined,
    SyncOutlined,
    CreditCardOutlined,
    StopOutlined,
    ExclamationCircleOutlined,
    ClockCircleOutlined
} from "@ant-design/icons-vue";

const columns = [
    {
        title: "รูปสินค้า",
        dataIndex: "ProductImage",
        width: "20%"
    },
    {
        title: "ข้อมูลสั่งซื้อ",
        dataIndex: "ShoppingJson",
        width: "45%"
    },
    {
        title: "ข้อมูลที่อยุ่จัดส่ง",
        dataIndex: "DeliveryJson",
        width: "35%"
    },
    {
        title: "กดสั่งวันที่",
        dataIndex: "ShoppingDate",
        width: "20%"
    },
    {
        title: "สถานะการโอนเงิน",
        dataIndex: "StatusPayment",
        width: "25%"
    },
    {
        title: "ช่องทางการชำระ",
        dataIndex: "PaymentType",
        width: "25%"
    },
    {
        title: "รูปสลิป(ลูกค้าแนบ)",
        dataIndex: "PathSlip",
        width: "25%"
    }

    // {
    //     title: "Link(ลูกค้าจ่ายเงิน)",
    //     dataIndex: "PaymentGetewayResponse",
    //     sorter: true,
    //     width: "20%"
    // }

    // {
    //     title: "ข้อความ Line",
    //     dataIndex: "Message",
    //     sorter: true,
    //     width: "25%"
    // },
    // {
    //     title: "Response",
    //     dataIndex: "ResponseLine",
    //     sorter: true,
    //     width: "15%"
    // },
    // {
    //     title: "PATH ลูกค้า ",
    //     dataIndex: "Url",
    //     width: "30%"
    // },
    // {
    //     title: "LineToken",
    //     dataIndex: "LineToken",
    //     width: "20%"
    // },
    // {
    //     title: "ข้อมูลเครื่องลูกค้า",
    //     dataIndex: "ClientUserAgent",
    //     width: "25%"
    // },
    // {
    //     title: "วันที่และเวลา",
    //     dataIndex: "LogCreateTime",
    //     width: "35%"
    // },
    // {
    //     title: "สถานะที่เกิดขึ้นจากเครื่องลูกค้า",
    //     dataIndex: "Type",
    //     width: "24%"
    // }
];

const queryData = params => {
    return axios.get("https://randomuser.me/api?noinfo", {
        params
    });
};

export default defineComponent({
    components: {
        TableLoad,
        // CheckOutlined,
        FromCreateSell,
        Pixcelview,
        FilePdfOutlined,
        FileExcelOutlined,
        LoadingOutlined,
        SyncOutlined,
        CreditCardOutlined,
        StopOutlined,
        ExclamationCircleOutlined,
        ClockCircleOutlined
    },

    setup() {
        const success = txt => {
            message.info(txt, 10);
        };
        const dataSources = ref([]);
        const rowselecteddetail = reactive({
            ishowdetail: false,
            rowselected: ""
        });
        const {
            data: dataSource,
            run,
            loading,
            title = "รายการลูกค้ากดสั่งของ shopping",
            current,
            pageSize
        } = usePagination("", {
            formatResult: res => res.data.results,
            pagination: {
                currentKey: "page",
                pageSizeKey: "results"
            }
        });
        const pagination = computed(() => ({
            total: 200,
            current: current.value,
            pageSize: pageSize.value
        }));

        const indicator = h(LoadingOutlined, {
            style: {
                fontSize: "24px"
            },
            spin: true
        });

        const isshowspin = ref(false);

        const list_result = ref([]);
        const getcalendar = async () => {
            await BzbsUser.getshoppingcartcalendar()
                .then(res => {
                    list_result.value = res.data;
                })
                .catch(error => {
                    console.log(error);
                });
        };
        onMounted(() => {
            getcalendar();
        });

        const updatedata = event => {
            if (event.updatedata) querycustomer();
        };

        const formatdate = date => {
            return moment(date)
                .add(543, "year")
                .format("LLL");
        };

        const groupBy = (collection, property) => {
            var i = 0,
                val,
                index,
                values = [],
                result = [];
            for (; i < collection.length; i++) {
                val = collection[i][property];
                index = values.indexOf(val);
                if (index > -1) result[index].push(collection[i]);
                else {
                    values.push(val);
                    result.push([collection[i]]);
                }
            }
            return result;
        };
        const getUniqueListBy = (arr, key) => {
            return [...new Map(arr.map(item => [item[key], item])).values()];
        };
        const querycustomer = () => {
            var param = {
                date: selectedValue.value.format("YYYY-MM-DD")
            };

            return BzbsUser.apigetshoppingcart(param)
                .then(res => {
                    // res.data[0].forEach((element, index) => {
                    //     res.data[0][index].key = index;
                    // });
                    dataSources.value = res.data;
                    // dataSources.value.forEach((element, index) => {
                    //     dataSources.value[index] = getUniqueListBy(element, "ProductSellOrder");
                    // });
                })
                .catch(error => {
                    console.log(error);
                });
        };
        const handleTableChange = (pag, filters, sorter) => {
            run({
                results: pag.pageSize,
                page: pag?.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters
            });
        };
        const rowselected = record => {
            rowselecteddetail.rowselected = record[0].CustomerOrder;
            rowselecteddetail.ishowdetail = true;
            console.log(record[0].CustomerOrder);
        };

        const groupBySellOrder = arraySellOrder => {
            return arraySellOrder.group(
                ({ ProductSellOrder }) => ProductSellOrder
            );
        };
        const date = ref(dayjs("2017-01-25"));
        const selectedValue = ref(dayjs("2017-01-25"));

        const onSelect = value => {
            date.value = value;
            selectedValue.value = value;
            showModalshoppingcart();
        };
        const onPanelChange = value => {
            date.value = value;
        };

        const getListData = value => {
            let listData;
            list_result.value.find(element => {
                if (element.Date == value.format("YYYY-MM-DD")) {
                    listData = [
                        {
                            type: "warning",
                            content: `มีลูกค้าสั่งซื้อ ${element.ShoppingCount} รายการ`
                        }
                    ];
                }
            });
            return listData || [];

            // switch (value.date()) {
            //     case 8:
            //         listData = [
            //             {
            //                 type: "warning",
            //                 content: "This is warning event."
            //             },
            //             {
            //                 type: "success",
            //                 content: "This is usual event."
            //             }
            //         ];
            //         break;
            //     case 10:
            //         listData = [
            //             {
            //                 type: "warning",
            //                 content: "This is warning event."
            //             },
            //             {
            //                 type: "success",
            //                 content: "This is usual event."
            //             },
            //             {
            //                 type: "error",
            //                 content: "This is error event."
            //             }
            //         ];
            //         break;
            //     case 15:
            //         listData = [
            //             {
            //                 type: "warning",
            //                 content: "This is warning event"
            //             },
            //             {
            //                 type: "success",
            //                 content: "This is very long usual event。。...."
            //             },
            //             {
            //                 type: "error",
            //                 content: "This is error event 1."
            //             },
            //             {
            //                 type: "error",
            //                 content: "This is error event 2."
            //             },
            //             {
            //                 type: "error",
            //                 content: "This is error event 3."
            //             },
            //             {
            //                 type: "error",
            //                 content: "This is error event 4."
            //             }
            //         ];
            //         break;
            //     default:
            // }
            // return listData || [];
        };
        const getMonthData = value => {
            if (value.month() === 8) {
                return 1394;
            }
        };

        const visibleshoppingcart = ref(false);
        const showModalshoppingcart = () => {
            querycustomer();
            visibleshoppingcart.value = true;
        };
        const handleOkshoppingcart = e => {
            console.log(e);
            visibleshoppingcart.value = false;
        };

        const getexcelshopping = async () => {
            isshowspin.value = true;
            await BzbsUser.apireportgetexcelshopping(dataSources.value)
                .then(async response => { 
                    const blob = await response.data;
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "shopping.xlsx"; // Set the desired filename
                    link.click();
                    isshowspin.value = false;
                })
                .catch(error => {
                    isshowspin.value = false;
                    console.log(error);
                });
        };
        const getexcelshoppingg_fill_in = async () => {
            isshowspin.value = true;
            var param = {
                date: selectedValue.value.format("YYYY-MM-DD")
            };
            await BzbsUser.apireportgetexcelshopping_fill_in(param)
                .then(async response => { 
                    const blob = await response.data;
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "shopping.xlsx"; // Set the desired filename
                    link.click();
                    isshowspin.value = false;
                })
                .catch(error => {
                    isshowspin.value = false;
                    console.log(error);
                });
        };
        return {
            showModalshoppingcart,
            handleOkshoppingcart,
            visibleshoppingcart,
            getListData,
            getMonthData,
            getListData,
            onSelect,
            selectedValue,
            onPanelChange,
            groupBy,
            groupBySellOrder,
            rowselecteddetail,
            rowselected,
            dataSource,
            dataSources,
            pagination,
            loading,
            title,
            columns,
            handleTableChange,
            querycustomer,
            formatdate,
            updatedata,
            getUniqueListBy,
            success,
            list_result,
            getexcelshopping,
            getexcelshoppingg_fill_in,
            indicator,
            isshowspin
        };
    }
});
</script>
<style lang="scss">
.ant-image-preview-img {
    margin: auto !important;
}

.ant-image-preview-img-wrapper {
    top: -880px !important;
}

.anticon svg {
    margin-top: -5px;
}

.ant-btn-dangerous {
    color: #000000 !important;
    background: #e6d495 !important;
    border-color: #b78c3b !important;
}

.ant-image-img {
    border-radius: 5px;
}

.anticon-copy {
    color: #000000 !important;
}

.events {
    list-style: none;
    margin: 0;
    padding: 0;
}
.events .ant-badge-status {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
}
.notes-month {
    text-align: center;
    font-size: 28px;
}
.notes-month section {
    font-size: 28px;
}

.pdf_icon {
    float: right;
    padding: 10px;
}
.ant-badge-status-text {
    font-size: 16px !important;
}
</style>
